<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="cartCode"
    >
      <template v-slot:img="{ row }">
        <b-img
          rounded
          alt="Rounded image"
          :src="
            row.defaultImage ? row.defaultImage : '/image/static/img/nopic.jpg'
          "
          style="width: 90px"
        ></b-img>
      </template>

      <template v-slot:samplename="{ row }">
        <span>{{ row.sampleStyleNo ? row.sampleStyleNo : '--' }}</span>
        <br />
        <span>{{ row.sampleNameEn ? row.sampleNameEn : '--' }}</span>
        <br />
        <span>
          <small>Size:{{ row.sampleSpec ? row.sampleSpec : '--' }}</small>
        </span>
        <br />
        <span>
          <small>Weight:{{ row.sampleWeight ? row.sampleWeight : '--' }}</small>
        </span>
      </template>

      <template v-slot:component="{ row }">
        <span>{{ row.componentEn ? row.componentEn : '--' }}</span>
      </template>

      <template v-slot:factoryprice="{ row }">
        <span>{{$l('table_label_costPrice') ||'成本价格'}}：{{ row.costPrice ? row.costPrice : '--' }}</span>
        <br />
        <span
          >{{ row.quotedMethod ? row.quotedMethod : '' }}{{$l('table_label_Price') ||'价格'}}：{{
            row.quotedPrice ? row.quotedPrice : '--'
          }}</span
        >
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.cartCode)"
              v-if="allow('D')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'

export default {
  mixins: [TableAutoHeight],
  props: {
    tablePage: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => {
            this.$emit('submit')
          },
        },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 50,
          fixed: 'left',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'checkbox',
          width: 40,
          align: 'center',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 100,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'defaultImage',
          title: this.$l('sample_table_label_image') || '图片',
          width: 110,
          align: 'center',
          slots: { default: 'img' },
        },
        {
          field: 'sampleNameEn',
          minWidth: 250,
          title: this.$l('sample_table_label_product') || '产品',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'left',
          slots: { default: 'samplename' },
        },
        {
          field: 'componentEn',
          minWidth: 250,
          title: this.$l('sample_table_label_component') || '成分',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'left',
          slots: { default: 'component' },
        },
        {
          field: 'factoryPrice',
          width: 250,
          title: this.$l('sample_table_label_price') || '价格',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          align: 'left',
          slots: {
            default: 'factoryprice',
          },
        },
      ],
    }
  },
  methods: {
    //单行删除
    del(code) {
      this.$emit('batchDel', [code])
    },
    //批量操作的验证操作
    getCheckboxRecords(type = 'code') {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_select_data') || '请选择数据！',
          type: 'warning',
        })
        return
      }

      if (type === 'code') {
        return data.map((row) => {
          return row.cartCode
        })
      }
      return data
    },
  },
}
</script>
